import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

const supportedActions = ['GET_POSTS', 'GET_NEW_POSTS', 'GET_OLDER_POSTS'];

export const consts = createReqConsts(
  'communities',
  'communityPosts',
  supportedActions,
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['communityId'],
    },
    'posts',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/communities/communityPosts.js